"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
const SCROLL_DURATION = 400; // milliseconds - lower = faster

function easeOutQuad(t: number): number {
  return t * (2 - t);
}
function smoothScrollTo(targetY: number, duration: number) {
  const startY = window.scrollY;
  const difference = targetY - startY;
  const startTime = performance.now();
  function step(currentTime: number) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeOutQuad(progress);
    window.scrollTo(0, startY + difference * easedProgress);
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }
  requestAnimationFrame(step);
}
export function SmoothScroll() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const handleClick = function handleClick(e) {
    const target = e.target as HTMLElement;
    const anchor = target.closest("a");
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute("href");
    if (!href || !href.startsWith("#")) {
      return;
    }
    const targetId = href.slice(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      e.preventDefault();
      const margin = Math.max(parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0, parseFloat(getComputedStyle(targetElement).scrollMarginTop) || 0);
      const targetY = targetElement.getBoundingClientRect().top + window.scrollY - margin;
      smoothScrollTo(targetY, SCROLL_DURATION);
      history.pushState(null, "", href);
    }
  };
  document.addEventListener("click", handleClick);
  return () => document.removeEventListener("click", handleClick);
}